import { styled } from '@mui/material/styles';
import { lighten } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
}));

/** Prefer Typography at call sites; kept for any legacy imports. */
export const Title = styled(Typography)(({ theme }) => ({
  margin: 0,
  paddingTop: theme.spacing(2),
  lineHeight: 1.2,
  fontWeight: 'bold',
}));

export const Content = styled('div')({
  flexGrow: 1,
  overflowY: 'auto',
});

export const PaddingTopBottom = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const PaddingBottom = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

export const ImagesContainer = styled('div')(({ theme }) => ({
  '& [type=secondarySub]': {
    marginBottom: theme.spacing(1),
  },

  '& .imagesList': {
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },

  '& .IMAGE': {
    paddingRight: theme.spacing(1),
  },
}));

export const RowOutline = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
  padding: `${theme.spacing(2)} 0`,
  float: 'left',
  width: '100%',
}));

export const ShowWrap = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(1)} 0`,
  '& .MuiToggleButtonGroup-root': {
    marginLeft: theme.spacing(1),
    '& button': {
      padding: `0px 5px`,
    },
  },
}));

export const CommentContainerInner = styled('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(),
  minHeight: theme.spacing(4),
}));

export const CommentWrapTitle = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
});

export const CommentCount = styled('div')(({ theme }) => ({
  fontSize: 13,
  marginLeft: theme.spacing(1),
}));

export const CommentBtnContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
}));

export const CommentBtn = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const CreateCommentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  position: 'relative',
  marginTop: theme.spacing(2),
  width: '100%',
  boxSizing: 'border-box',
  ...(!isMobile && {
    marginLeft: 'auto',
    marginRight: 'auto',
  }),

  '& .titleContainer': {
    margin: 0,

    // Form defaults this to title_large (22px), same as the "Comments" heading
    // above. Sit between body text and that heading.
    '& .text-title_large': {
      fontSize: 18,
      fontWeight: 500,
    },
  },

  // Force the inner Form to span the full comment container width and not
  // be centered (PFM-2599 QA round 1: comment body input was rendering at
  // 640px centered, leaving the form misaligned and the submit/cancel
  // buttons floating off to the right of empty space).
  '& [class*="formContainer"]': {
    maxWidth: 'none !important',
    margin: 0,
    width: '100%',
  },
}));

export const CancelBtn = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  '&:hover': {
    backgroundColor: lighten(theme.palette.error.main, 0.1),
  },
}));

export const SubmitButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',

  '& button': {
    marginRight: 0,
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));
